import { SET_STORY_EDITOR_CHAT } from 'admin/constants/actions';

export type SetStoryEditorChatPayload = {
	open: boolean;
	draft?: { id: string; text: string };
};

export function setStoryEditorChat(payload: SetStoryEditorChatPayload) {
	return { type: SET_STORY_EDITOR_CHAT, payload };
}
